import { CartesianGrid, Line, LineChart, XAxis, YAxis } from 'recharts';

import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import {
  type ChartConfig,
  ChartContainer,
  ChartTooltip,
  ChartTooltipContent,
} from '@/components/ui/chart';
import { Skeleton } from '@/components/ui/skeleton';

const callVolumeChartConfig = {
  volume: {
    label: 'Volume',
    color: '#3b82f6',
  },
} satisfies ChartConfig;

type Props = {
  loading: boolean;
  data: { date: string; volume: number }[];
};

export const CallVolumeTrendChart = ({ loading, data }: Props) => {
  return (
    <Card className="bg-muted rounded-2xl p-1 pt-0 gap-0 border-0 shadow-none flex flex-col">
      <CardHeader className="flex flex-col px-5 py-3">
        <CardTitle className="text-sm">Call volume trend</CardTitle>
      </CardHeader>
      <CardContent className="flex flex-col gap-3 bg-card p-5 rounded-xl shadow-sm flex-1">
        {loading ? (
          <div className="space-y-3">
            <Skeleton className="h-4 w-32" />
            <Skeleton className="w-full min-h-[200px]" />
          </div>
        ) : (
          <ChartContainer config={callVolumeChartConfig} className="h-[240px]">
            <LineChart
              accessibilityLayer
              data={data}
              margin={{ left: 8, right: 8, top: 8, bottom: 8 }}
            >
              <CartesianGrid strokeDasharray="3 3" vertical={false} />
              <XAxis dataKey="date" tickLine={false} axisLine={false} tickMargin={8} />
              <YAxis tickLine={false} axisLine={false} tickMargin={8} />
              <ChartTooltip content={<ChartTooltipContent />} />
              <Line
                type="monotone"
                dataKey="volume"
                stroke="var(--color-volume)"
                strokeWidth={2}
                dot={false}
              />
            </LineChart>
          </ChartContainer>
        )}
      </CardContent>
    </Card>
  );
};
